import React from "react";
import { Table, Button, Card } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import useComplaince from "Hooks/AdminHooks/useComplaince";

const Complaince = () => {
  const {
    columns,
    data,
    loading,
    setAddPolicyModalVisible,
    AddPolicyModal,
    VersionModal,
    DetailsModal,
    ConfirmPolicyModal,
    ConfirmVersionModal,
  } = useComplaince();

  return (
    <DashboardLayout>
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <DashboardNavbar />
        <div className="body flex-grow-1 px-3">
          <Card
            title={
              <div className="d-flex align-items-center">
                <span>Compliance Policies Management</span>
              </div>
            }
            className="card-professional"
            extra={
              <Button
            
                icon={<PlusOutlined />}
                onClick={() => setAddPolicyModalVisible(true)}
              >
                Add New Policy
              </Button>
            }
          >
            <Table
              className="table-responsive custom-compliance-table"
              dataSource={data}
              columns={columns}
              rowKey={(record) =>
                record.complianceId ?? record.id ?? record.policyId ?? record.key
              }
              loading={loading}
              pagination={{
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
              }}
            />
          </Card>

          {/* All Modals */}
          <AddPolicyModal />
          <VersionModal />
          <DetailsModal />
          <ConfirmPolicyModal />
          <ConfirmVersionModal />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Complaince;
